export default "__VITE_ASSET__bqV5POFU__"